import { StatusBadge } from '@/components/common/StatusBadge';
import { APPROVAL_STATUS_TONE } from '@/styles/statusColors';
import {
  DECISION_LABEL,
  DECISION_TONE,
  DONATION_DECISION,
} from '../constants/marketPromotion.constants';

interface DecisionStatusBadgeProps {
  approveTypeNo: number;
}

export function DecisionStatusBadge({ approveTypeNo }: DecisionStatusBadgeProps) {
  return (
    <StatusBadge tone={DECISION_TONE[approveTypeNo] ?? APPROVAL_STATUS_TONE.pending}>
      {DECISION_LABEL[approveTypeNo] ?? DECISION_LABEL[DONATION_DECISION.PENDING]}
    </StatusBadge>
  );
}
